import styled from 'styled-components';

export const TagWrapper = styled.div`
  & > div:hover,
  .ant-tag > div:hover {
    cursor: pointer;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary.blue};
  }
`;
